import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';

export class LabelColors {
  static IN_VISIT = colors.mrBlueSky;

  static PAST = colors.peaches;

  static UPCOMING = colors.grannySmith;
}

export class LabelText {
  static IN_VISIT = "You're checked in";

  static PAST = 'Visit Complete';

  static UPCOMING = 'Confirmed visit';
}

const Root = styled.div.withConfig({ componentId: 'sc-ij06q0-0' })`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 0;
`;

const CardType = styled.div.withConfig({ componentId: 'sc-ij06q0-1' })`
  ${(props) => css`
    color: ${props.color};
    font-size: ${fontSize.small};
    font-family: ${fontFamily.bold};
    text-transform: uppercase;
  `}
`;

type Props = {
  label: any; // TODO: oneOf([LabelText.IN_VISIT, LabelText.PAST, LabelText.UPCOMING])
  labelColor: any; // TODO: oneOf([LabelColors.IN_VISIT, LabelColors.PAST, LabelColors.UPCOMING])
};

class Label extends Component<Props> {
  render = () => {
    const { label, labelColor } = this.props;
    return (
      <Root>
        <CardType color={labelColor}>{label}</CardType>
      </Root>
    );
  };
}

export default Label;
